<!-- eslint-disable -->
<template lang="pug">
    .error-container
        .error-container__background
            .error-container__header(@click="redirectToDashboard" :style="{cursor: 'pointer'}")
                    img.error-container__logo(src="../../assets/images/logo.svg")
            .error-container__body
                router-view
</template>

<script>
    export default {
        methods: {
            redirectToDashboard() {
                this.$router.push({ name: 'dashboard' });
            },
        },
    };
</script>

<style scoped lang="scss">
    /*eslint-disable*/
    .error-container {
        display: flex;
        align-items: stretch;
        flex-direction: column;
        min-height: 100vh;
        background: $hsl-color-green-58;
    }

    .error-container__background {
        flex-shrink: 0;
        flex-grow: 1;
        display: flex;
        align-items: stretch;
        flex-direction: column;
        background: url('../../assets/images/background.svg');
        background-size: cover;
    }

    .error-container__header {
        text-align: center;
        padding: 40px 15px 0 15px;
        flex-grow: 0;
        flex-shrink: 0;
    }

    .error-container__logo {
        width: 100%;
        @include media($sm) {
            width: auto;
        }
    }

    .error-container__body {
        padding-top: 42px;
        flex-shrink: 0;
        flex-grow: 1;
    }
</style>
